import React from 'react'
import Search from './Search'
import SetupPage from 'modules/setup/SetupPage'
import PotenciaInfoTab from './potenciaInfo/PotenciaInfoTab'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

const PotenciaSetup = () => {

	const setupProps = {
		title: "Potencias",
		icon: faSquare,
		addNewTitle: "Crear potencia",
		searchUrl: "/potenciaSetup/search",
		rowKey: "idPotencia",
		columns: [
			{ key: "idPotencia", name: "ID", sortable: true, width: 60 },
			{ key: "nombre", name: "Nombre", sortable: true },
		],
		tabs: [
			{ key: "info", title: "Info", comp: PotenciaInfoTab }
		]
	};

	return (
		<SetupPage
			setupProps={setupProps}
			search={Search} />
	)
}

export default PotenciaSetup;